import { getServerHostname } from '@flipster/utils/env-helper';
import { Fetcher } from '@flipster/utils/fetcher';

const baseURL = getServerHostname();
const origin = baseURL.replace(/api[.-]/, '');

const headers: Record<string, string> = {
  origin,
  'x-prex-client-platform': 'web',
  'x-prex-client-version': process.env.NEXT_PUBLIC_VERSION ?? '',
};

if (process.env.CF_AUTH) headers['x-prex-authorization'] = process.env.CF_AUTH;

export const fetchClient = new Fetcher({
  baseURL: `${baseURL}/api`,
  headers,
});
